import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import Typography from 'app/ui/components/atoms/typography';
import { generateBreadcrumbs } from 'app/utils/breadcrumbs';

import { useIntl } from 'react-intl';

const Wrapper = styled.div`
  display: inline-flex;
  gap: 0.5rem;
  margin: ${({ theme }) => `0 0 ${theme.spacing(6)}`};
  overflow: hidden;

  & > :last-child {
    word-break: break-word;
  }
`;

const LastBreadcrumb = styled(Typography)`
  color: ${({ theme }) => theme.colors.lightGray};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type BreadcrumbProps = {
  contentTitle: string;
  dynamicSegments?: Record<string, string>;
};

const Breadcrumb: React.FC<BreadcrumbProps & { className?: string }> = ({
  contentTitle,
  dynamicSegments,
  className,
}) => {
  const theme = useTheme();
  const intl = useIntl();
  const location = useLocation();

  const breadcrumbs = generateBreadcrumbs({ intl, pathname: location.pathname, contentTitle, dynamicSegments });

  return (
    <Wrapper className={className}>
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={`bcb-${breadcrumb.title}`}>
          {index > 0 && (
            <Typography key={`sep-${breadcrumb.title}`} variant="body2" color={theme.colors.lightGray}>
              &gt;
            </Typography>
          )}
          {breadcrumb.href ? (
            <Link to={breadcrumb.href}>
              <Typography variant="body2" color={theme.colors.lightGray}>
                {breadcrumb.title}
              </Typography>
            </Link>
          ) : (
            <LastBreadcrumb variant="body2">{breadcrumb.title}</LastBreadcrumb>
          )}
        </React.Fragment>
      ))}
    </Wrapper>
  );
};

export default Breadcrumb;
